import classNames from 'clsx'

import { EXPERIMENT_VARIATION } from 'shared/experiments/consts'
import './SearchSuggestion.scss'
import MountPoints from 'shared/utils/mountPoints'
import withMountPoints from 'views/enhancers/withMountPoints'

type SearchSuggestionProps = {
  suggestion: string
  variation: `${EXPERIMENT_VARIATION}`
  mountPoints: MountPoints
  currentQuery: string
}

const SearchSuggestion = ({
  suggestion,
  variation,
  mountPoints,
  currentQuery,
}: SearchSuggestionProps) => {
  const suggestionContainerClasses = classNames(
    'u-margin--left u-border-radius u-color--dark u-background-color--background u-padding-xx-small--ends u-padding-small--sides o-SearchSuggestionLink',
    {
      'u-border':
        variation === EXPERIMENT_VARIATION.V1 ||
        variation === EXPERIMENT_VARIATION.V2,
      'o-SearchSuggestion__hover': variation === EXPERIMENT_VARIATION.V2,
      'o-SearchSuggestion__no-hover u-text-decoration--none':
        variation === EXPERIMENT_VARIATION.V1 ||
        variation === EXPERIMENT_VARIATION.V3,
      'o-SearchSuggestionText__hover': variation === EXPERIMENT_VARIATION.V4,
      'u-border--none':
        variation === EXPERIMENT_VARIATION.V3 ||
        variation === EXPERIMENT_VARIATION.V4,
    }
  )

  return (
    <a
      className={suggestionContainerClasses}
      href={mountPoints.getSearch({
        query: `${currentQuery + ' ' + suggestion}`,
      })}
    >
      {suggestion}
    </a>
  )
}

export default withMountPoints(SearchSuggestion)
